import { createFileRoute, useSearch } from '@tanstack/react-router';
import type { SsoLoginError } from '@vizit/organisms';
import { LoginPage } from '../../pages';

type SsoSearch = {
  error?: SsoLoginError;
  redirect?: string;
};

export const Route = createFileRoute('/_auth/sso/')({
  staticData: {
    pageName: 'SSO Login',
  },
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): SsoSearch => {
    return {
      error: (search.error as SsoLoginError) ?? undefined,
      redirect: (search.redirect as string) ?? undefined,
    };
  },
});

function RouteComponent() {
  const { error: errorFromSearch, redirect: redirectFromSearch } = useSearch({
    from: Route.id,
  });

  return <LoginPage errorFromSearch={errorFromSearch} redirectFromSearch={redirectFromSearch} />;
}
